import {
    MinLabelIcon,
    MaxLabelIcon,
    MidLabelIcon,
} from '@/assets/theme/default/walletIcons/minMaxLabel';
import { usePhrase } from '@/hooks';
import { WALLET_PHRASES } from '@/consts/phrases/walletPhrases';
import { Typography } from '@mui/material';
import { Currency } from '@/components/general/Currency/Currency';

import styles from './WalletMinMaxLabel.module.css';

interface WalletMinMaxLabelProps {
    amountMax?: number;
    amountMin?: number;
    currencyCode: string;
    currencySymbol: string | undefined;
    currencyPosition?: string;
}

export const WalletMinMaxLabel = ({
    amountMax,
    amountMin,
    currencySymbol,
    currencyCode,
    currencyPosition,
}: WalletMinMaxLabelProps) => {
    const { t } = usePhrase();

    const hasNoAmountDetails = !amountMax && !amountMin;
    const isMinimalAmountLabel = !amountMax && amountMin;
    const isMaximumAmountLabel = !amountMin && amountMax;
    const isRangeAmountLabel = amountMin && amountMax;

    if (hasNoAmountDetails) return null;

    return (
        <span className={`${styles.WalletMinMaxLabel} WalletMinMaxLabel`}>
            {isMinimalAmountLabel && <MinLabelIcon data-testid="MinLabelIcon" />}
            {isMaximumAmountLabel && <MaxLabelIcon data-testid="MaxLabelIcon" />}
            {isRangeAmountLabel && <MidLabelIcon data-testid="MidLabelIcon" />}

            {(isMinimalAmountLabel || isRangeAmountLabel) && (
                <span className={styles.labelGradation}>
                    <Typography variant="greyLabel">{t(WALLET_PHRASES.MINIMUM_AMOUNT)}</Typography>
                    <Typography variant="greyLabel">
                        <Currency
                            symbol={currencySymbol}
                            position={currencyPosition}
                            code={currencyCode}
                            amount={amountMin}
                        />
                    </Typography>
                </span>
            )}

            {(isMaximumAmountLabel || isRangeAmountLabel) && (
                <span className={styles.labelGradation}>
                    <Typography variant="greyLabel">{t(WALLET_PHRASES.MAXIMUM_AMOUNT)}</Typography>
                    <Typography variant="greyLabel">
                        <Currency
                            symbol={currencySymbol}
                            position={currencyPosition}
                            code={currencyCode}
                            amount={amountMax}
                        />
                    </Typography>
                </span>
            )}
        </span>
    );
};
